import {Component} from '@angular/core';
import {FilterService} from '../shared/filter.service';

// Just the shell: sets up the sidebar for this screen and hosts the routed section
// (yield-protection / optimization-schedule / protected-buckets / markets /
// system-settings - see the 'configuration' children in app.module.ts). Each section
// owns its own state, its own load, and its own Save in its own component - this class
// deliberately knows nothing about any of that.
@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html'
})
export class ConfigurationComponent {
    constructor(private filterService: FilterService) {
        this.filterService.updateFilterLayout({
            screenName: 'configuration',
            toolbarHidden: true,
            // The sidebar template dereferences journeyFilterConfig.isRequired unconditionally,
            // so it must be present even though the filter sidebar is hidden on this screen.
            journeyFilterConfig: {
                dropDownType: 'single',
                isRequired: false
            },
            hidden: []
        });
    }
}
